module.exports = __webpack_public_path__ + "media/src/images/io-loading-5970faf1355e1bf3d58e6bd8931c3f7a.gif";